import { IScenarioAnalysisReportCard } from '@/interfaces/scenarioAnalysisReportComponents.interface'
import { CloseFullscreen, OpenInFull } from '@mui/icons-material'
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Stack,
} from '@mui/material'
import React from 'react'
import GridActions from '../Base/GridActions/actions'

export const ScenarioAnalysisReportCard: React.FC<
  IScenarioAnalysisReportCard
> = ({
  cardId,
  isFocused,
  toggleFocus,
  title,
  children,
  defaultGridColumn,
  defaultGridRow,
  focusedGridColumn,
  focusedGridRow,
  focusAllowed,
  showIcon,
  gridReference,
}) => {
  return (
    <Box
      display='grid'
      p={0}
      width='100%'
      sx={{
        gridColumn: isFocused ? focusedGridColumn : defaultGridColumn,
        gridRow: isFocused ? focusedGridRow : defaultGridRow,
      }}
      zIndex={isFocused ? 9 : 'initial'}
      id={cardId}
      data-cy={cardId}
    >
      <Card>
        <CardHeader
          title={title}
          action={
            <Stack direction='row'>
              {showIcon && <GridActions gridApiRef={gridReference} />}
              {focusAllowed && (
                <IconButton size='small' onClick={() => toggleFocus(cardId)}>
                  {isFocused ? (
                    <CloseFullscreen fontSize='inherit' />
                  ) : (
                    <OpenInFull fontSize='inherit' />
                  )}
                </IconButton>
              )}
            </Stack>
          }
          sx={{ pb: 2 }}
        />
        <CardContent
          sx={{
            py: cardId !== 'scenariosTable' ? '0 !important' : 1,
            display: 'grid',
            alignItems: 'center',
            boxSizing: 'border-box',
            height: 'calc(100% - 48px)',
          }}
        >
          {children}
        </CardContent>
      </Card>
    </Box>
  )
}
